import { isEmpty } from 'lodash-es';

//discount good for ranges or without ranges of sale items...
// ? [REVISIT] what is going on here?
export const processBadgeDiscount = (originalPrice: number, price: number, maxPrice?: number) => {
  let minDiscount = maxPrice ? ((originalPrice - maxPrice) / originalPrice) * 100 : undefined;
  let regDiscount: number = ((originalPrice - price) / originalPrice) * 100;
  minDiscount = minDiscount && (minDiscount >= 18 ? customRound(minDiscount) : Math.round(minDiscount));
  regDiscount = regDiscount >= 18 ? customRound(regDiscount) : Math.round(regDiscount);

  const discount =
    minDiscount && regDiscount - minDiscount !== 0
      ? minDiscount + '–' + regDiscount + '% Off'
      : regDiscount
      ? regDiscount + '% Off'
      : undefined;

  return discount;
};

export const processBadgeUrgency = (
  inventoryBySize: Partial<Record<string, number | undefined>> | undefined | null,
  sizeOptions: string[] | undefined
): boolean => {
  if (!sizeOptions || isEmpty(sizeOptions) || isEmpty(inventoryBySize)) return false;

  const optionsUnderThreshold = sizeOptions
    .map((itemOption) => inventoryBySize?.[itemOption ?? 'DNE_KEY'] ?? 0)
    .filter((item) => item < 10).length;

  return optionsUnderThreshold / sizeOptions.length > 0.5;
};

// Merch wants to round down or up a specific way
// 37.9% => 30%
// 38% => 40%
const customRound = (number: number) => {
  const roundedNumber = number % 10 >= 8 ? Math.ceil(number / 10) : Math.floor(number / 10);
  return roundedNumber * 10;
};
